import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { supportedMetricsSelector, intervalSelector } from '@store/common/selectors';
import { allDimensionsListSelector } from '@store/common/dimensionList/selectors';
import { createTempDashboard } from '@store/tempDashboard/actions';
import { drilldownDashboardType } from '@src/components/common/Dashboard/UseCases';
import {
  getValidateDimensionFunc,
  getValidateMetricFunc,
} from '@src/components/common/Dashboard/UseCases/utils';
import { getServerSidePerformancePreset } from '@src/components/common/Dashboard/UseCases/configs/eco';
import { useMultiDimensionFilters } from './useMutilDimensionFilters';
import { initialFilter } from '@src/store/common/reducer';
import { getFilterFromRules, getRulesFromFilter } from '@src/utils';

// drill down to Service Performance
export const useDrillDownToSSP = (ddDimensions, rowData) => {
  const metrics = useSelector(supportedMetricsSelector) as object;
  const dimensions = useSelector(allDimensionsListSelector) as [];
  const formattedInterval = useSelector(intervalSelector);
  const dispatch = useDispatch();
  const filters = useMultiDimensionFilters(ddDimensions, rowData);

  const handleDrillDown = useCallback(() => {
    const { config, title, key } = getServerSidePerformancePreset({
      validateDimension: getValidateDimensionFunc(dimensions),
      validateMetric: getValidateMetricFunc(metrics),
    });

    const newRules = getRulesFromFilter(filters, true);
    const newFilter = getFilterFromRules(newRules, true);
    const drilldownFilters = [initialFilter, newFilter];

    dispatch(
      createTempDashboard(
        drilldownDashboardType,
        {
          ...config,
          common: {
            ...(config.common ?? {}),
            appliedFilters: [newFilter],
            interval: formattedInterval,
          },
          summary: {
            drilldownData: drilldownFilters,
          },
          usecaseKey: key,
        },
        title,
      ),
    );
  }, [dimensions, metrics, filters, dispatch, formattedInterval]);

  return handleDrillDown;
};
